exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button-wrapper[data-v-013090bc] {\n  display: block;\n  overflow: hidden;\n  text-align: right;\n}\n.button-wrapper button[data-v-013090bc] {\n  display: inline-block;\n  background: #FFCD50;\n  color: #fff;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n.button-wrapper button[data-v-013090bc]:disabled {\n  background: #4a4a4a;\n  cursor: not-allowed;\n}\n@media screen and (max-width: 767px) {\n.button-wrapper[data-v-013090bc] {\n    padding: 1em 0 0;\n}\n.button-wrapper button[data-v-013090bc] {\n    padding: 1rem 2em;\n    margin: 0 auto;\n    text-align: center;\n    width: 100%;\n}\n}", ""]);

// exports
